import React from 'react';
import { Button } from './Button';
import { ShieldCheck, Zap, Lock, Crown } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-14 md:py-24 px-4 sm:px-6 lg:px-8 bg-zinc-950 relative overflow-hidden" data-id="element-81">
      <div className="absolute inset-0 bg-gradient-to-b from-[#00b8ff]/5 via-transparent to-[#ff2e92]/5 pointer-events-none" data-id="element-82"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-83">
        <div className="text-center mb-10 md:mb-12" data-id="element-84">
          <h2 className="text-3xl md:text-5xl font-bold mb-3 md:mb-4" data-id="element-85">
            Accedé hoy al Mega Kit Scooter
          </h2>
          <p className="text-base md:text-xl text-zinc-400" data-id="element-86">
            Acceso inmediato y de por vida. Pago único, sin suscripciones.
          </p>
        </div>

        <div className="rounded-3xl p-6 md:p-10 relative bg-zinc-900 border-2 border-[#00b8ff] shadow-[0_0_40px_rgba(0,184,255,0.25)]" data-id="element-87">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-88">
            <div className="bg-gradient-to-r from-[#00b8ff] to-[#ff2e92] text-white font-bold py-1.5 md:py-2 px-4 md:px-6 rounded-full text-xs md:text-sm flex items-center gap-2 shadow-lg whitespace-nowrap" data-id="element-89">
              <Crown className="w-3 h-3 md:w-4 md:h-4" data-id="element-90" />
              OFERTA EXCLUSIVA
            </div>
          </div>

          <div className="text-center mb-6 md:mb-8 mt-4" data-id="element-91">
            <div className="text-5xl md:text-6xl mb-3 md:mb-4" data-id="element-92">🛴</div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-93">
              MEGA KIT SCOOTER COMPLETO
            </h3>
            <p className="text-sm md:text-base text-zinc-400" data-id="element-94">
              6 Tomos + 6 Bonos Exclusivos
            </p>
          </div>

          <div className="text-center mb-6 md:mb-8" data-id="element-95">
            <p className="text-zinc-500 text-xl md:text-2xl line-through mb-1 md:mb-2" data-id="element-96">
              $49.990
            </p>
            <p className="text-5xl md:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#00b8ff] to-[#ff2e92]" data-id="element-97">
              $19.990
            </p>
            <p className="text-xs md:text-sm text-zinc-500 mt-2" data-id="element-98">
              Pesos Argentinos · Pago Único
            </p>
          </div>

          <Button href="https://checkout.palabravivasoporte.com/cart/47686659571875:1" className="w-full text-lg md:text-2xl py-4 md:py-5 animate-pulse hover:animate-none" data-id="element-99">
            ¡QUIERO MI MEGA KIT AHORA!
          </Button>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-zinc-400 text-xs md:text-sm font-medium mt-6 md:mt-8" data-id="element-100">
            <div className="flex items-center gap-2" data-id="element-101">
              <Lock className="w-4 h-4 md:w-5 md:h-5 text-green-400" data-id="element-102" />
              <span data-id="element-103">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-104">
              <Zap className="w-4 h-4 md:w-5 md:h-5 text-yellow-400" data-id="element-105" />
              <span data-id="element-106">Acceso en 5 min</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-107">
              <ShieldCheck className="w-4 h-4 md:w-5 md:h-5 text-blue-400" data-id="element-108" />
              <span data-id="element-109">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}